import { AfterViewChecked, AfterViewInit, Component, importProvidersFrom, inject} from '@angular/core';
import { CommonModule, } from '@angular/common';
import { NavbarComponent } from '../../components/navbars/navbar/navbar.component';
import { SideMenuComponent } from '../../components/navbars/side-menu/side-menu.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { DataService } from '../../Services/Data Service/data.service';
import { AuditService } from '../../Services/Data Service/audit.service';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../Auth/auth.service';
import { isSuperAdminRole } from '../../roles';
import { filter, switchMap, take } from 'rxjs';
declare var M: any;


interface Faq {
  intFaqPK: number;
  strQuestion: string;
  strAnswer: string;
}

importProvidersFrom(HttpClientModule)
@Component({
  selector: 'app-admin-hub',
  standalone: true,
  imports: [NavbarComponent, SideMenuComponent,CommonModule,FormsModule],
  templateUrl: './admin-hub.component.html',
  styleUrl: './admin-hub.component.css'
})

export class AdminHubComponent{
  constructor(private apiService: DataService, private auditService: AuditService, private auth: AuthService) {}

  creatingQuestion: boolean = false;
  createButton: string = 'Create New Question';
  systems: any;
  pages: any
  //pageItems : PageItem[] =[];
  faqItems: Faq[] = [];
  auditLog: any[] = [];
  originalAuditLog: any[] = [];
  userMap: Map<number, string> = new Map();

  users:any;
  currUser: any;

  error_message ="";
  
  http= inject(HttpClient)

  activeTab: string = 'tab1';

  title = 'Procurement Administrator';
  isNavbarExpanded = false;

  loading = false;

  hideBtn = false;

  submissionsRestricted = false;
  settingsLoading = false;
  settingsSaving = false;
  readonly isSuperAdminRole = isSuperAdminRole;

  newFaqItem = {
    strAnswer: '',
    strQuestion: ''
  }

  ngOnInit(): void { 
    this.fetchData()
    this.creatingQuestion = false;
    this.loadSubmissionsSettings();
    this.loadAuditLog();

    this.apiService.currentUser$.pipe(
      filter((u): u is NonNullable<typeof u> => u != null),
      take(1)
    ).subscribe({
      next: (loggedInUser) => {
        if (!loggedInUser.role) {
          console.error('User not found.');
          this.loading = false;
          return;
        }
        this.currUser = loggedInUser;
      }
    });
  };

  loadSubmissionsSettings(): void {
    this.settingsLoading = true;
    this.apiService.getSubmissionsSettings().subscribe({
      next: (settings) => {
        this.submissionsRestricted = settings.submissionsRestricted;
        this.settingsLoading = false;
      },
      error: () => {
        this.settingsLoading = false;
      },
    });
  }

  toggleSubmissionsRestriction(): void {
    if (!isSuperAdminRole(this.currUser?.role) || this.settingsSaving) {
      return;
    }
    this.settingsSaving = true;
    const nextValue = !this.submissionsRestricted;
    this.apiService.updateSubmissionsSettings(nextValue).subscribe({
      next: (settings) => {
        this.submissionsRestricted = settings.submissionsRestricted;
        this.settingsSaving = false;
        this.auditService.submitAuditLog(
          settings.submissionsRestricted
            ? 'Restricted new vendor submissions'
            : 'Allowed new vendor submissions'
        );
      },
      error: () => {
        this.settingsSaving = false;
        this.error_message = 'Failed to update submission settings. Please try again.';
      },
    });
  }

  fetchData():void{
    //FETCH PAGE CONTENT FROM DB     
    //FETCH FAQ CONTENT FROM DB 
    this.apiService.getFaqItems().subscribe({
      next: (result) => {
        this.faqItems = result;
        console.log('Filtered FAQ Items:', result);
      }, error: (error) => {
        console.error('Error:', error);
      },
    });

    this.apiService.getUsers().subscribe({
      next: (result3) => {
        this.users = result3;
      }, error: (error) => {
        console.error('Error:', error);
      },
    });
  }
    
  loadAuditLog() {
    this.loading = true;
    this.apiService.getAllUsers().pipe(
      switchMap((users) => {
        // Build a lookup map: adminId -> name
        users.forEach(user => {
          this.userMap.set(user.intUserPK, user.strName);
        });
        return this.apiService.getAuditLog();
      })
    ).subscribe({
      next: (logs) => {
        this.originalAuditLog = logs.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
        this.auditLog = this.originalAuditLog;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }
  
  getUserName(adminId: number): string {
    return this.userMap.get(adminId) || 'Unknown';
  }
  
  formatDate(dateStr: string): string {
    return new Date(dateStr).toLocaleString();
  }

  toggleCollapse(expanded: boolean) {
    this.isNavbarExpanded = expanded;
  }


  toggleCollapsible(event: Event) {
    const header = event.currentTarget as HTMLElement;
    const body = header.nextElementSibling as HTMLElement;

    if (body.classList.contains('open')) {
      body.classList.remove('open');
    } else {
      body.classList.add('open');
    }
  }

  expand(body: HTMLElement) {
    body.style.maxHeight = body.scrollHeight + 'px';
    body.style.opacity = '1'; 

    body.classList.add('open');

    body.addEventListener('transitionend', function resetMaxHeight() {
      body.style.maxHeight = '';
      body.removeEventListener('transitionend', resetMaxHeight);
    });
  }

  collapse(body: HTMLElement) {
    body.style.maxHeight = body.scrollHeight + 'px';

    body.offsetHeight; 
    body.style.maxHeight = '0';
    body.style.opacity = '0';

    body.addEventListener('transitionend', function removeOpenClass() {
      body.classList.remove('open');
      body.removeEventListener('transitionend', removeOpenClass);
    });
  }

  index: any;
  selectedQuestion: any = null;


  //FAQ
  onQuestionChange(selectedQuestion: any) {
    if (selectedQuestion) {
      console.log('Selected:', selectedQuestion);
      this.selectedQuestion = selectedQuestion;
    }
  }

  onFaqChange() {
    if (this.selectedQuestion) {
      const index = this.faqItems.findIndex(
        (item) => item.intFaqPK === this.selectedQuestion.intFaqPK
      );
      if (index > -1) {
        // Update fields in place without replacing the object
        this.faqItems[index].strAnswer = this.selectedQuestion.strAnswer;
        this.faqItems[index].strQuestion = this.selectedQuestion.strQuestion;
      }
    }
  }
  

  createQuestion(): void {
    if (this.createButton == 'Go Back'){
      this.creatingQuestion = false;
      this.createButton = 'Create New Question';
      this.hideBtn = false;
    }
    else{
      this.creatingQuestion = true; 
      this.createButton = 'Go Back';
      this.hideBtn = true;
    }
  };

  saveFAQ(): void{ 
    this.loading = true;

    this.apiService.addFaqItems(this.newFaqItem).subscribe({
      next: (result) => {
        this.loading = false;
        this.auditService.submitAuditLog("Added new FAQ question.");
        this.fetchData()

      const snackbar = document.getElementById('snackbar');

      if (snackbar) {
        // Type assertion to allow custom property
        const snackbarElement = snackbar as HTMLElement & { timeoutId?: number };
      
        // Clear any existing timeouts
        if (snackbarElement.timeoutId) {
          clearTimeout(snackbarElement.timeoutId);
        }
      
        // Reset visibility and opacity
        snackbarElement.style.visibility = 'visible';
        snackbarElement.style.opacity = '1';
        snackbarElement.innerText = 'Saved successfully.';
      
        // Add the 'show' class for animations
        snackbarElement.classList.add('show');
      
        // Set a timeout to hide the snackbar and store the timeout ID
        snackbarElement.timeoutId = setTimeout(() => {
          snackbarElement.style.visibility = 'hidden';
          snackbarElement.style.opacity = '0';
          snackbarElement.classList.remove('show');
        }, 3000) as unknown as number; ;
      }
    },
    error: (error) => {
      this.loading = false;
      console.error('Error:', error);
      const snackbar = document.getElementById('snackbar');

      if (snackbar) {
        snackbar.style.visibility = 'visible';
        snackbar.innerText = 'Error updating. Try again.';

        snackbar.classList.add('show');
        setTimeout(() => {
          snackbar.style.visibility = 'hidden';
          snackbar.style.opacity = '0';
        }, 3000);
      }
    },
  })};



  //PAGE CONFIGURATIONS Method
  //This method updates the page items
  onPageSubmit(){
    this.loading = true;
    
    const updateRequests = this.faqItems.map((item) => {
      console.log("Item", item);
      const payload = {
        strQuestion: item.strQuestion,
        strAnswer: item.strAnswer
      };
      console.log("Payload", payload);

      this.auditService.submitAuditLog("Made changes to FAQ question.");
      return this.apiService.setFaqItems(item.intFaqPK, payload).toPromise();
    });
      Promise.all(updateRequests)
      .then(() => {
        this.loading = false;
        console.log('All updates were successful');

        const snackbar = document.getElementById('snackbar');

        if (snackbar) {
          // Type assertion to allow custom property
          const snackbarElement = snackbar as HTMLElement & { timeoutId?: number };
        
          // Clear any existing timeouts
          if (snackbarElement.timeoutId) {
            clearTimeout(snackbarElement.timeoutId);
          }
        
          // Reset visibility and opacity
          snackbarElement.style.visibility = 'visible';
          snackbarElement.style.opacity = '1';
          snackbarElement.innerText = 'Saved successfully.';
        
          // Add the 'show' class for animations
          snackbarElement.classList.add('show');
        
          // Set a timeout to hide the snackbar and store the timeout ID
          snackbarElement.timeoutId = setTimeout(() => {
            snackbarElement.style.visibility = 'hidden';
            snackbarElement.style.opacity = '0';
            snackbarElement.classList.remove('show');
          }, 3000) as unknown as number; ;
        }
        
      })
      .catch((error) => {
        this.loading = false;
        console.error('Error updating items:', error);
        const snackbar = document.getElementById('snackbar');

        if (snackbar) {
          snackbar.style.visibility = 'visible';
          snackbar.innerText = 'Error updating. Try again.';

          snackbar.classList.add('show');
          setTimeout(() => {
            snackbar.style.visibility = 'hidden';
            snackbar.style.opacity = '0';
          }, 3000);
        }
      });

  }

  selectedActivity: string = ''; // For storing the selected status
  sortVisible: boolean = false; // To toggle dropdown visibility
  data$: any;

  // FOR AUDIT LOG DROP DOWN
  toggleDropdown(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.sortVisible = !this.sortVisible;
  }
  
  ngAfterViewInit(): void {
    const elems = document.querySelectorAll('.dropdown-trigger');
    M.Dropdown.init(elems, {
      constrainWidth: false,
      coverTrigger: false,
    });
  }


  filterByActivity(status: string, event?: Event): void {
    // Reset to the original unfiltered data before applying the filter
    this.auditLog = [...this.originalAuditLog];

    this.selectedActivity = status;
  
    if (status === 'Approved') {
      this.auditLog = this.auditLog.filter(log => log.activity.includes('Approved'));
    } else if (status === 'Declined') {
      this.auditLog = this.auditLog.filter(log => log.activity.includes('Declined vendor:'));
    } else if (status === 'Sent Back') {
      this.auditLog = this.auditLog.filter(log => log.activity.includes('Sent'));
    } else if (status === 'Flags') {
      this.auditLog = this.auditLog.filter(log => 
        ['Flagged vendor', 'Unflagged vendor'].some(activity => log.activity.includes(activity))
      );
    } else if (status === 'Notes') {
      this.auditLog = this.auditLog.filter(log => log.activity.includes('note'));
    } else if (status === 'FAQ') {
      this.auditLog = this.auditLog.filter(log => log.activity.includes('FAQ'));
    } else {
      this.auditLog = [...this.auditLog];
    }
  
    this.sortVisible = false;
  }
  
  

}